import styles from "./BrandStoryMotion.module.css";

type BrandStoryMotionVariant = "pulse" | "bridge" | "system" | "craft";

/** Brand-owned motion artwork built from GRUV's ticket, line and pulse language. */
export function BrandStoryMotion({
  variant,
}: {
  variant: BrandStoryMotionVariant;
}) {
  return (
    <div className={`${styles.artwork} ${styles[variant]}`} aria-hidden="true">
      <div className={styles.grid} />
      <span className={styles.label}>
        CULTURAL ENERGY / TECHNOLOGICAL PRECISION
      </span>
      {variant === "pulse" ? (
        <>
          <div className={styles.stage}>
            <span />
            <span />
            <span />
            <span />
            <span />
          </div>
          <div className={styles.pulseLine} />
          <div className={styles.ticketMark}>
            <b>G</b>
            <i />
          </div>
          <div className={styles.orbit}>
            <span />
          </div>
        </>
      ) : null}
      {variant === "bridge" ? (
        <>
          <div className={styles.bridgeTrack}>
            <span>DESCUBRIR</span>
            <i />
            <span>ENTRAR</span>
            <i />
            <span>VIVIR</span>
          </div>
          <div className={styles.bridgeTicket}>
            <b>GRUV</b>
            <span>→</span>
          </div>
          <div className={styles.bridgeGlow} />
        </>
      ) : null}
      {variant === "system" ? (
        <>
          <div className={styles.systemCore}>GRUV</div>
          {["DISPONIBLE", "SEGURO", "ESCALABLE", "CONFIABLE"].map(
            (item, index) => (
              <div className={styles.systemNode} data-node={index} key={item}>
                {item}
              </div>
            ),
          )}
          <svg
            className={styles.systemLines}
            viewBox="0 0 600 360"
            focusable="false"
            aria-hidden="true"
          >
            <path d="M300 180 110 82M300 180 490 82M300 180 110 278M300 180 490 278" />
          </svg>
        </>
      ) : null}
      {variant === "craft" ? (
        <>
          <div className={styles.craftWord}>GRUV</div>
          <div className={styles.craftScan} />
          <div className={styles.craftTags}>
            <span>ESCUCHAR</span>
            <span>CONSTRUIR</span>
            <span>MEJORAR</span>
          </div>
        </>
      ) : null}
    </div>
  );
}
